// Enregistrements différés (préférences 0,8 s, apprentissage 1,5 s) qui partent avant de quitter la page,
// et préférences synchronisées entre appareils.
// --- ENREGISTREMENTS DIFFÉRÉS : rien ne se perd en changeant de page ------------------------------------------
// Les préférences (0,8 s) et le journal d'apprentissage (1,5 s) partent au serveur avec un léger différé, pour
// grouper les changements. Or changer d'onglet charge une autre page : un clic dans la seconde qui suit perdait le
// dernier changement, et il n'y a plus de copie locale pour le rattraper. Chaque différé s'inscrit donc ici, et
// avant de quitter la page (lien interne, changement d'onglet), tout ce qui attend part d'abord — la navigation
// suit dès la réponse, au plus tard après 2 s. Au déchargement brutal (fermeture, rechargement), envoi keepalive.
window.__enAttente = {};
window.enAttente = function(nom, envoyer) { window.__enAttente[nom] = envoyer; };
window.plusEnAttente = function(nom) { delete window.__enAttente[nom]; };
window.flushEnAttente = function(cb, opts) {
    var noms = Object.keys(window.__enAttente);
    if (!noms.length) { if (cb) cb(); return; }
    var reste = noms.length, fini = false;
    var termine = function() { if (fini) return; fini = true; if (cb) cb(); };
    noms.forEach(function(n) { var f = window.__enAttente[n]; delete window.__enAttente[n]; f(function() { if (--reste <= 0) termine(); }, opts); });
    if (cb) setTimeout(termine, 2000);
};
window.__quitte = false;
window.addEventListener('pagehide', function() { window.__quitte = true; window.flushEnAttente(null, { keepalive: true }); });
window.addEventListener('pageshow', function() { window.__quitte = false; });
// Clic sur un lien interne (onglets, pied de page, accueil) : les enregistrements en attente partent d'abord.
document.addEventListener('click', function(ev) {
    if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a || a.target === '_blank') return;
    var brut = a.getAttribute('href') || '';
    if (/^(javascript:|#|mailto:|tel:)/i.test(brut) || a.href.indexOf(location.origin) !== 0) return;
    // Un lien vers un onglet du site (en-tête, barre du bas, marque, pied de page…) : on change d'onglet sur place.
    // Les enregistrements en attente n'ont plus besoin d'être forcés — la page ne se décharge pas, ils partiront.
    var seg = (a.pathname || '').replace(/\/+$/, '').split('/').pop().replace(/\.html?$/i, '');
    var tab = (seg === '' || seg === 'index') ? 'accueil' : (window.ONGLET_PAR_ROUTE[seg] || null);
    if (tab && !a.search && window.state && window.state.isAuthenticated !== false) {
        if (tab === 'accueil' && !window.renderAccueil) tab = 'dashboard';
        ev.preventDefault();
        window.actions.switchTab(tab);
        return;
    }
    // Autre page du site (mentions légales, déconnexion…) : les enregistrements en attente partent d'abord.
    if (window.__spaTest || !Object.keys(window.__enAttente).length) return;
    ev.preventDefault();
    var href = a.href;
    window.flushEnAttente(function() { location.assign(href); });
}, true);

var prefsTimer = null;
window.prefsPayload = function() {
    return { subParts: window.state.subParts, subPartsArchive: window.state.subPartsArchive, regroupSeuilMots: window.state.regroupSeuilMots, subPartSections: window.state.subPartSections, splitProposals: window.state.splitProposals, splitLots: window.state.splitLots, exams: window.state.exams, podcastSpeed: window.state.podcastSpeed, podcastPos: window.state.podcastPos, podcastVoices: window.state.podcastVoices, podcastExplicatif: window.state.podcastExplicatif, currentPlanningId: window.state.currentPlanningId, theme: window.themeChoisi(), taskTimers: window.state.taskTimers, lissagePaliers: window.state.lissagePaliers, updated: Date.now() };
};
window.savePrefs = function() {
    clearTimeout(prefsTimer);
    var envoyer = function(cb, opts) {
        clearTimeout(prefsTimer); window.plusEnAttente('prefs');
        window.syncWithServer('save_prefs', { prefs: window.prefsPayload() }, function() { if (cb) cb(); }, opts);
    };
    window.enAttente('prefs', envoyer);
    prefsTimer = setTimeout(function() { envoyer(); }, 800);
};

window.loadPrefsFromServer = function(cb) {
    window.syncWithServer('get_prefs', {}, function(d) { window.applyServerPrefs(d); if (cb) cb(d); });
};
window.applyServerPrefs = function(d) {
    (function() {
        if (!d || !d.success) return;
        var p = d.prefs;
        if (!p) { if (Object.keys(window.state.subParts).length || window.state.exams.length) window.savePrefs(); return; }
        var changed = false, localMissing = false;
        // Découpages regroupés : l'archive du serveur complète la locale, et un item archivé n'est pas re-scindé
        // par la fusion des sous-parties ci-dessous (c'est justement lui qu'on a regroupé).
        Object.keys(p.subPartsArchive || {}).forEach(function(k) { if (!window.state.subPartsArchive[k] && Array.isArray(p.subPartsArchive[k]) && p.subPartsArchive[k].length) window.state.subPartsArchive[k] = p.subPartsArchive[k]; });
        // L'archive vient peut-être d'arriver : les flashcards des sous-parties d'un item regroupé de longue date
        // rejoignent alors le paquet de l'item (sans effet si c'est déjà fait).
        if (window.reparerDecksRegroupes) window.reparerDecksRegroupes();
        if (p.regroupSeuilMots > 0) window.state.regroupSeuilMots = p.regroupSeuilMots;
        Object.keys(p.subParts || {}).forEach(function(k) {
            if (window.state.subPartsArchive[k]) return;
            if (!window.state.subParts[k] && Array.isArray(p.subParts[k]) && p.subParts[k].length) { window.state.subParts[k] = p.subParts[k]; changed = true; }
        });
        Object.keys(window.state.subParts).forEach(function(k) { if (!(p.subParts || {})[k]) localMissing = true; });
        Object.keys(p.subPartSections || {}).forEach(function(k) {
            if (!window.state.subPartSections[k]) { window.state.subPartSections[k] = p.subPartSections[k]; changed = true; }
        });
        Object.keys(window.state.subPartSections).forEach(function(k) { if (!(p.subPartSections || {})[k]) localMissing = true; });
        Object.keys(p.splitLots || {}).forEach(function(k) {
            if (!window.state.splitLots[k]) { window.state.splitLots[k] = p.splitLots[k]; changed = true; }
        });
        Object.keys(window.state.splitLots).forEach(function(k) { if (!(p.splitLots || {})[k]) localMissing = true; });
        Object.keys(p.splitProposals || {}).forEach(function(k) {
            var mine = window.state.splitProposals[k] || [], have = {};
            mine.forEach(function(x) { have[x.t] = 1; });
            (p.splitProposals[k] || []).forEach(function(x) { if (x && x.t && !have[x.t]) { mine.push(x); changed = true; } });
            if (mine.length) window.state.splitProposals[k] = mine.sort(function(a, b) { return b.t - a.t; }).slice(0, 5);
        });
        Object.keys(window.state.splitProposals).forEach(function(k) { if (!(p.splitProposals || {})[k] || (p.splitProposals[k] || []).length < window.state.splitProposals[k].length) localMissing = true; });
        var ids = {}; window.state.exams.forEach(function(e) { ids[e.id] = 1; });
        (p.exams || []).forEach(function(e) { if (e && e.id && !ids[e.id]) { window.state.exams.push(e); changed = true; } });
        if (window.state.exams.length !== (p.exams || []).length) localMissing = true;
        // podcasts : rien n'est gardé dans le navigateur, le serveur fait foi (sauf ce qui vient d'être fait localement)
        if (p.podcastSpeed && !window.state.podcastSpeedSet) window.state.podcastSpeed = p.podcastSpeed;
        if (Array.isArray(p.lissagePaliers) && p.lissagePaliers.length) window.state.lissagePaliers = p.lissagePaliers;
        Object.keys(p.podcastPos || {}).forEach(function(k) { if (!(k in window.state.podcastPos)) window.state.podcastPos[k] = p.podcastPos[k]; });
        Object.keys(window.state.podcastPos).forEach(function(k) { if (!Object.prototype.hasOwnProperty.call(p.podcastPos || {}, k)) localMissing = true; });
        if (p.podcastVoices && !window.state.podcastVoices.A && !window.state.podcastVoices.B) window.state.podcastVoices = { A: p.podcastVoices.A || '', B: p.podcastVoices.B || '' };
        if (window.player && window.player.audio) window.player.audio.playbackRate = window.state.podcastSpeed || 1;
        if (typeof p.podcastExplicatif === 'boolean' && !window.state.podcastExplicatifSet) window.state.podcastExplicatif = p.podcastExplicatif;
        if ((p.theme === 'jour' || p.theme === 'nuit' || p.theme === 'auto') && !window.state.themeSet && p.theme !== window.themeChoisi()) {
            try { if (p.theme === 'auto') localStorage.removeItem('edn_theme'); else localStorage.setItem('edn_theme', p.theme); } catch (e) {}
            window.appliquerTheme(); window.renderHeader(); window.renderFooter();
        }
        Object.keys(p.taskTimers || {}).forEach(function(k) { if (!window.state.taskTimers[k]) { window.state.taskTimers[k] = p.taskTimers[k]; changed = true; } });
        if (changed) {
            window.storageSet('edn_subparts_global', JSON.stringify(window.state.subParts));
            window.storageSet('edn_subpart_sections', JSON.stringify(window.state.subPartSections));
            window.storageSet('edn_split_proposals', JSON.stringify(window.state.splitProposals));
            window.storageSet('edn_exams', JSON.stringify(window.state.exams));
            window.renderApp();
        }
        if (localMissing) window.savePrefs();
    })();
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const enAttente = window.enAttente;
export const plusEnAttente = window.plusEnAttente;
export const flushEnAttente = window.flushEnAttente;
export const prefsPayload = window.prefsPayload;
export const savePrefs = window.savePrefs;
export const loadPrefsFromServer = window.loadPrefsFromServer;
export const applyServerPrefs = window.applyServerPrefs;
